/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation SmppActiveInActiveMutation($smppId: ID!, $clearSmppBuild: Boolean, $isActive: Boolean!) {
    SmppActiveInActive(smppId: $smppId, clearSmppBuild: $clearSmppBuild, isActive: $isActive) {
        isActive,
        message
        status
    }
} 
`

